import { createCollection, localOnlyCollectionOptions } from "@tanstack/react-db";
import { SmartCardRow } from "@/domains/tanstack-db/repositories/smart-cards/schemas";
import { SMART_CARDS_COLLECTION_ID } from "./constants";

export interface SmartCardLocalCollectionOptions {
  initialData?: Array<SmartCardRow>;
}

export const createSmartCardLocalCollection = (options: SmartCardLocalCollectionOptions = {}) =>
  createCollection(
    localOnlyCollectionOptions<SmartCardRow, string>({
      id: SMART_CARDS_COLLECTION_ID,
      getKey: card => card.id,
      initialData: options.initialData,
    })
  );
